// Angular
import { Observable, Observer, fromEvent, map, merge } from 'rxjs';
import { Injectable } from '@angular/core';

// Libraries

@Injectable({
	providedIn: 'root',
})
export class UtilityService {
	constructor() {}

	isOnline() {
		return merge<any>(
			fromEvent(window, 'offline').pipe(map(() => false)),
			fromEvent(window, 'online').pipe(map(() => true)),
			new Observable((sub: Observer<boolean>) => {
				sub.next(navigator.onLine);
				sub.complete();
			})
		);
	}

	simulateWindowResize() {
		window.dispatchEvent(new Event('resize'));
	}

	initializeChartScrolling(wrapperSelector: string = '.table-wrapper') {
		// Apply mat-table body scrolling.
		// This is a solution is a workaround to the inherent limitations of the Material Table
		// which offers, row-scrolling, with a fixed header, but the scrollbar oddly goes into
		// the space of the table header causing an expected/bad UX. This fixes that by applying
		// the scrollbar only to the mat-table (body rows), while still keeping the mat-header
		// pinned to the top (sticky = true).
		setTimeout(() => {
			const tableWrapperSelector: string = wrapperSelector;
			const tableWrapper = document.querySelector(tableWrapperSelector);
			const headerRow = document.querySelector(`${tableWrapperSelector} mat-header-row`);
			const matTable = document.querySelector(`${tableWrapperSelector} mat-table`);
			if (tableWrapper && headerRow && matTable) {
				tableWrapper.insertBefore(headerRow, matTable);
			}
		}, 1);
	}

	buildUrlParams(data: any): string {
		return Object.entries(data)
			.map(([key, val]) => {
				if (![undefined, null].includes(val)) {
					// @ts-ignore
					return `${key}=${encodeURIComponent(val)}`;
				}
			})
			.filter((item) => item !== undefined)
			.join('&');
	}
}
